@if(showImg){
<div class="w-50 m-auto text-center">
  <img src="assets/warning.svg" alt="" width="182" />
</div>
}
<div class="alert alert-danger mt-4 m-auto text-center mobile" role="alert">
  {{ error }}
</div>
